import { Controller } from "@hotwired/stimulus"

// Toggle HTML vs plain-text email bodies and autosize sandboxed srcdoc iframes.
// Sandbox includes allow-same-origin (not allow-scripts) so we can measure height
// without letting email content execute JavaScript.
export default class extends Controller {
    static targets = ["htmlPanel", "plainPanel", "htmlBtn", "plainBtn"]

    connect() {
        this._mode = "html"
        this._autosizeFrames()
    }

    showHtml(event) {
        if (event) event.preventDefault()
        this._mode = "html"
        this._syncPanels()
        this._autosizeFrames()
    }

    showPlain(event) {
        if (event) event.preventDefault()
        this._mode = "plain"
        this._syncPanels()
    }

    _syncPanels() {
        if (this.hasHtmlPanelTarget) this.htmlPanelTarget.classList.toggle("d-none", this._mode !== "html")
        if (this.hasPlainPanelTarget) this.plainPanelTarget.classList.toggle("d-none", this._mode !== "plain")
        if (this.hasHtmlBtnTarget) this.htmlBtnTarget.classList.toggle("is-active", this._mode === "html")
        if (this.hasPlainBtnTarget) this.plainBtnTarget.classList.toggle("is-active", this._mode === "plain")
    }

    _autosizeFrames() {
        this.element.querySelectorAll("iframe[data-email-frame]").forEach((frame) => this._autosizeFrame(frame))
    }

    _autosizeFrame(frame) {
        if (!frame) return
        let resize = () => {
            try {
                let doc = frame.contentDocument
                if (!doc || !doc.documentElement) return
                let height = Math.max(doc.documentElement.scrollHeight, doc.body ? doc.body.scrollHeight : 0)
                if (height > 0) frame.style.height = `${height + 24}px`
            } catch {
                // Should not happen with allow-same-origin srcdoc; keep CSS fallback.
            }
        }
        frame.addEventListener("load", () => {
            resize()
            setTimeout(resize, 300)
            setTimeout(resize, 1200)
        })
        resize()
    }
}
